import { BatchStatus } from 'Services/SalesManagement/Features/TicketSale/types'

const CANCELLABLE_BATCH_STATUSES: Set<BatchStatus> = new Set([
  BatchStatus.QUEUED,
  BatchStatus.PROCESSING,
  BatchStatus.PROCESSED,
  BatchStatus.PARTIALLY_PROCESSED
])

export function isBatchCancellable(status?: BatchStatus): boolean {
  return status ? CANCELLABLE_BATCH_STATUSES.has(status) : false
}
